<script lang="ts">
import { defineComponent, watch } from "vue";

export default defineComponent({
  name: "Vorschlagsliste",
  props: {
    vorschlaege: Array as any,
    anzeigen: Boolean,
    selected: Number,
  },
  setup(props) {
    watch(
      () => props.selected,
      (werteNeu) => {
        const topPos = document.getElementById("item-" + werteNeu)?.offsetTop;
        const elementById = document.getElementById("listElement");
        if (elementById && topPos !== undefined) {
          elementById.scrollTo(0, topPos);
        }
      },
    );

    const getOptionlabel = (option: any) => {
      let label = "";
      if (typeof option === "string") {
        return option;
      }
      Object.values(option).forEach((value) => {
        if (value) {
          label += label !== "" ? " " + value : value;
        }
      });
      return label;
    };
    return { props, getOptionlabel };
  },
});
</script>

<template>
  <div tabindex="0" v-if="anzeigen" class="autocomplete" id="listElement">
    <ul>
      <li
        v-for="(option, index) in vorschlaege"
        :key="index"
        @click="$emit('update', { data: option, index: index })"
        :class="{ selected: index === selected }"
        :id="'item-' + index"
      >
        {{ getOptionlabel(option) }}
      </li>
    </ul>
  </div>
</template>

<style lang="scss">
.autocomplete {
  position: relative;
  margin-top: -0.625rem;
  max-height: 160px;
  overflow: auto;
  border: 1px solid #e7eef2;

  ul {
    padding: 0;
    margin: 0;
    overflow: auto;

    li {
      list-style: none;
      text-align: left;
      cursor: pointer;
      padding: 4px 0.875rem;
    }

    li:hover {
      background-color: #599F7C;
      color: white;
    }

    .selected {
      background-color: #599F7C;
      color: white;
    }
  }
}
</style>
